module.exports = __webpack_public_path__ + "img/FI01999207.a2bf8691.png";